import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from 'react-router-dom';
import { Routes } from "../../routes";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCog, faHome, faSearch, faSync } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, InputGroup, Dropdown, Table, Alert } from '@themesberg/react-bootstrap';
import Breadcrumb from '../../components/Breadcrumb';
import MeasurementNavigation from '../../components/MeasurementNavigation';

/*import { TransactionsTable } from "../../components/Tables";*/
import geoNow from '../../utils/geonow';
import { useSelector } from 'react-redux';

import { ReactTabulator } from 'react-tabulator';
import 'react-tabulator/lib/styles.css';
import 'react-tabulator/css/bootstrap/tabulator_bootstrap.css';

import Swal from 'sweetalert2';
import moment from "moment-timezone";
import 'moment/locale/zh-tw';

import * as XLSX from 'xlsx';
import Select from 'react-select';


import { getLightFilterOptions, getStatusLight, matchesLightFilter } from "../../utils/statusLights";
import { formatStatusLight } from "../../utils/statusLightFormatter";
import { thresholdRangeColumn } from "../../utils/thresholdRangeFormatter";
import { loadDataOverview, getOverviewDataMessage, getOverviewErrorMessage } from "../../utils/dataOverview";
import {
    combineStatusNotes,
    escapeStatusMessageHtml
} from "../../utils/statusMessages";

const pageSizeStorageKey = 'geoNow.dataOverview.pageSize';
const pageSizeOptions = [10, 50, 100, true];

function readSavedPageSize() {
    try {
        const savedSize = JSON.parse(localStorage.getItem(pageSizeStorageKey));
        return pageSizeOptions.includes(savedSize) ? savedSize : 10;
    } catch {
        return 10;
    }
}

export default (props = {}) => {

    const history = useHistory();

    const rdx_project = useSelector(state => state.project);
    const rdx_user = useSelector(state => state.user);
    const token = rdx_user.token;
    const lastName = rdx_user.lastName
    const firstName = rdx_user.firstName

    const tableRef = useRef(null);
    const [pageSize, setPageSize] = useState(readSavedPageSize);
    
    const selectedProject = rdx_project.currentProjectId
        ? geoNow.stateHelper.project.getJoinedProjectItemByProjectId(rdx_project.currentProjectId, rdx_project.joinedProjects || [])
        : null;

    const [statusData, setStatusData] = useState(null);
    const [measurementHistory, setMeasurementHistory] = useState(null);
    const [historySelection, setHistorySelection] = useState(null);
    // A history cursor belongs to its project; switching projects starts at latest.
    const selection = historySelection && historySelection.projectId === selectedProject?.projectId ? historySelection.selection : null;
    const historical = Boolean(selection?.at || selection?.meaNo != null);
    const [loadError, setLoadError] = useState(null);
    const [loadWarnings, setLoadWarnings] = useState([]);
    const [filteredStatusDataEntries, setfilteredStatusDataEntries] = useState(null);

    const [filterOptions, setFilterOptions] = useState(null);

    const [gageDefinitionsMap, setGageDefinitionsMap] = useState(null);
    const [areaList, setAreaList] = useState(null);
    const [tagList, setTagList] = useState([]);
    const [selectedTagIds, setSelectedTagIds] = useState([]);
    const [groupMode, setGroupMode] = useState("none");

    const [loadingProp, setLoadingProp] = useState({
        isLoading: false,
        closeModal: false
    });
    const bypassCacheOnNextLoad = useRef(false);
    const [reloadSequence, setReloadSequence] = useState(0);

    useEffect(() => { setHistorySelection(null); }, [selectedProject?.projectId]);

    React.useEffect(() => {
        if (loadingProp.isLoading) {
            Swal.fire({
                title: "讀取中...",
                showConfirmButton: false,
                allowOutsideClick: true,
                allowEscapeKey: true,
                didOpen: () => {
                    Swal.showLoading()
                }
            });
        } else if (loadingProp.closeModal) {
            Swal.close();
        }

        return () => {
            Swal.close();
        };
    }, [loadingProp]);


    //async function tryFillingStatusData() {
    //    let resStatusData = await geoNow.api.siteData.getLatestDataWithAlert(token, selectedProject.projectId);
    //    setStatusData(resStatusData);
    //}
    //async function tryFillingGageDefinition() {
    //    let resGageDef = await geoNow.api.siteData.getGageDefinition(token, [selectedProject.projectId], true);
    //    const mapGafeDef = new Map(resGageDef.items[0].map(el => [el.code, el]));
    //    setGageDefinitionsMap(mapGafeDef);
    //}
    //async function tryFillingAreaList() {
    //    let resAreaList = await geoNow.api.siteData.getAreas(token, selectedProject.projectId);
    //    setAreaList(resAreaList);
    //}

    // ### USE EFFECT ## BEGIN ##]
    React.useEffect(() => {
        if (!selectedProject?.projectId) {
            setStatusData(null);
            setMeasurementHistory(null);
            setfilteredStatusDataEntries(null);
            setLoadError(null);
            setLoadWarnings([]);
            setLoadingProp({ isLoading: false, closeModal: true });
            return;
        }

        let isCurrentProjectRequest = true;
        const projectId = selectedProject.projectId;
        const bypassCache = bypassCacheOnNextLoad.current;
        bypassCacheOnNextLoad.current = false;

        setStatusData(null);
        setMeasurementHistory(null);
        setfilteredStatusDataEntries(null);
        setLoadError(null);
        setLoadWarnings([]);
        setGageDefinitionsMap(null);
        setAreaList(null);
        setTagList([]);
        setLoadingProp({ isLoading: true, closeModal: false });
        loadDataOverview(geoNow.api, token, projectId, bypassCache, selection || {}).then(result => {
            if (!isCurrentProjectRequest) return;
            setStatusData(result.data);
            setMeasurementHistory(result.history);
            setGageDefinitionsMap(new Map(result.gageList.map(gage => [Number(gage.code), gage])));
            setAreaList(result.areaList);
            setTagList(result.tagList);
            setLoadWarnings(result.warnings);
            // 清掉已消失的選項，避免重新整理後被舊篩選條件隱藏。
            setFilterOptions(options => ({
                ...options,
                gageFilter: result.gageList.some(gage => String(gage.code) === String(options?.gageFilter))
                    ? options.gageFilter : "null",
                areaFilter: result.areaList.items.includes(options?.areaFilter) ? options.areaFilter : "null"
            }));
            setSelectedTagIds(ids => ids.filter(id => result.tagList.some(tag => tag.id === id)));
            setLoadingProp({ isLoading: false, closeModal: true });
        }).catch(error => {
            if (!isCurrentProjectRequest) return;
            setLoadError(getOverviewErrorMessage(error));
            setLoadingProp({ isLoading: false, closeModal: true });
        });
        //return;
        let customDataFieldOrderString = selectedProject.projectCustomDataFieldOrder;
        let customDataFieldOrder = customDataFieldOrderString?.split(',');

         //adjust tabulatorColumns according to customDataFieldOrder
         //if customDataFieldOrder is null or empty, it means no need to adjust the order of the fields nor does it need to hide any field.
         //if customDataFieldOrder is not null, it means it needs to adjust the order of the fields and hide some fields, according to the customDataFieldOrder's keys and their order.
         //however, some keys may have different names, so it needs to be mapped to the actual field names, according to geoNow.stateHelper.project.customDataField.keys's members.
         //comments end here. start coding.
        
        if (customDataFieldOrder && customDataFieldOrder.length > 0) {

            // 建立一個映射表用於存放原始的 tabulatorColumns
            let originalTabulatorColumnsMap = {};
            for (let i = 0; i < tabulatorColumns.length; i++) {
                originalTabulatorColumnsMap[tabulatorColumns[i].field] = tabulatorColumns[i];
            }

            // 建立一個新陣列用於存放排序後的 columns
            let newTabulatorColumns = [];

            // 對每一組 key-value pair 做處理
            for (let i = 0; i < customDataFieldOrder.length; i++) {
                let key = customDataFieldOrder[i];


                // 根據 geoNow.stateHelper.project.customDataField.keys 的成員映射到實際欄位名稱
                switch (key) {
                    case geoNow.stateHelper.project.customDataField.keys.alert:
                        key = 'lAlert';
                        break;
                    case geoNow.stateHelper.project.customDataField.keys.alarm1:
                        key = 'lAlarm1';
                        break;
                    case geoNow.stateHelper.project.customDataField.keys.alarm2:
                        key = 'lAlarm2';
                        break;
                    case geoNow.stateHelper.project.customDataField.keys.action:
                        key = 'lAction';
                        break;
                    case geoNow.stateHelper.project.customDataField.keys.pointIdx:
                        key = 'pointIdx';
                        break;
                    case geoNow.stateHelper.project.customDataField.keys.light:
                        key = 'threeLight';
                        break;
                    default:
                        break;
                }

                // 如果此欄位存在於原始的 tabulatorColumns 中
                if (originalTabulatorColumnsMap[key]) {
                    // 設定此欄位的可見性
                    originalTabulatorColumnsMap[key].visible = true;

                    // 將此欄位插入到新陣列中
                    let item = originalTabulatorColumnsMap[key];

                    newTabulatorColumns.push(item);

                    // 從映射表中移除此欄位，以防止重複插入
                    delete originalTabulatorColumnsMap[key];
                }
            }

            // 將剩餘的欄位（不在 customDataFieldOrder 中的）添加到新陣列中，並設置為不可見
            for (let key in originalTabulatorColumnsMap) {
                originalTabulatorColumnsMap[key].visible = false;
                newTabulatorColumns.push(originalTabulatorColumnsMap[key]);
            }
            // re assign the column named 'ThreeLight's formatter with new project's display kind
            let threeLightColumn = newTabulatorColumns.find(item => item.field === 'threeLight');
            if (threeLightColumn) {
                threeLightColumn.accessorDownload = (value, data) => getStatusLight(data, selectedProject).colorName;
                threeLightColumn.formatter = (cell, formatterParams, onRendered) => {
                    return getTabulatorThreeLightFormatter(cell, formatterParams, onRendered, selectedProject);
                };
            }
            
            setTabuatorColumns(newTabulatorColumns);
            //if (tableRef && tableRef.current) {
            //    tableRef.current.setColumns(newTabulatorColumns);
            //}
            
        } else {
            setTabuatorColumns(defaultTabulatorColumns);
            //if (tableRef && tableRef.current) {
            //    tableRef.current.setColumns(defaultTabulatorColumns);
            //}
            
        }
        if (tableRef && tableRef.current) {
            // refresh the table
            tableRef.current.redraw(true);
        }

        return () => {
            isCurrentProjectRequest = false;
        };

        //tryFillingStatusData();
        //tryFillingGageDefinition();
        //tryFillingAreaList();
    }, [selectedProject, token, reloadSequence, selection]);

    React.useEffect(() => {
        setFilterOptions({ lightFilter: "all", gageFilter: "null", areaFilter: "null" });
        setSelectedTagIds([]);
    }, [selectedProject?.projectId, selectedProject?.projectStatusLogicMode]);

    //Update Data Presents WHENEVER data or filterOption changes    
    React.useEffect(() => {
        if (statusData === null) {
            return; //; however, if data is NULL, do nothing to prevent NULL error from happening.
        }


        let fData = statusData.entries;
        if (filterOptions !== null) {

            fData = fData.filter(item => matchesLightFilter(item, filterOptions.lightFilter, selectedProject));

            if (filterOptions.gageFilter) {
                let g = filterOptions.gageFilter;
                if (g !== null && g !== "null") {
                    fData = fData.filter(item => {
                        let is = item.gageTypeCode == g;
                        // console.log(item);
                        return is;
                    });
                }
            }

            if (filterOptions.areaFilter) {
                let ar = filterOptions.areaFilter;
                if (ar !== null && ar !== "null") {
                    fData = fData.filter(item => {
                        let is = item.area == ar;
                        // console.log(item);
                        return is;
                    });
                }
            }

        }

        if (selectedTagIds.length > 0) {
            fData = fData.filter(item =>
                selectedTagIds.some(tagId => (item.tagIds || []).includes(tagId))
            );
        }

        setfilteredStatusDataEntries(fData);
    }, [statusData, filterOptions, selectedTagIds, selectedProject]);

    React.useEffect(() => {
        if (!tableRef.current) return;
        tableRef.current.setGroupBy(
            groupMode === "area" ? "area" : groupMode === "tags" ? "tagGroup" : false
        );
    }, [groupMode, filteredStatusDataEntries]);
    // ### USE EFFECT ## END ##]

    const tabluatorOptions = {
        pagination: true,
        paginationSize: pageSize,
        paginationSizeSelector: pageSizeOptions,
        responsiveLayout: true
    };

    const colorFilterOptions = getLightFilterOptions(selectedProject);
    function reloadData() {
        bypassCacheOnNextLoad.current = true;
        setReloadSequence(value => value + 1);
    }
    function clearFilters() {
        setFilterOptions({ lightFilter: "all", gageFilter: "null", areaFilter: "null" });
        setSelectedTagIds([]);
    }
    const noFilterResults = statusData?.entries.length > 0 && filteredStatusDataEntries?.length === 0;


    function renderAreaDropdownOptions() {
        if (areaList && areaList.items) {
            return areaList.items.map(item => {
                return (<option key={item} value={item}>{item}</option>);
            });
        }
    }

    function renderGageDropdownOptions() {
        if (gageDefinitionsMap) {
            let entries = Array.from(gageDefinitionsMap, ([k, v]) => (v));
            if (entries) {
                return entries.map(item => {
                    return (<option key={item.code} value={item.code}>{item.gageDescription}</option>);
                });
            }
        }
    }

    function handleAreaFilterOnChange(filterValue) {
        setFilterOptions({
            ...filterOptions,
            areaFilter: filterValue
        })
    }

    function handleGageFilterOnChange(filterValue) {
        setFilterOptions({
            ...filterOptions,
            gageFilter: filterValue
        })
    }

    function handleLightFilterOnChange(filterValue) {
        setFilterOptions({
            ...filterOptions,
            lightFilter: filterValue
        });
    }
    const getTabulatorThreeLightFormatter = (cell, formatterParams, onRendered, project) => formatStatusLight(cell, project);

    const defaultTabulatorColumns = [
        {
            field: "threeLight",
            visible: true,
            width: 30,
            minWidth: 30,
            maxWidth: 30,
            resizable: false,
            download: false,
            /**
             * @param {any} cell The cell component
             * @param {any} formatterParams Parameters set for the column
             * @param {any} onRendered Function to call when the formatter has been rendered
             */
            formatter: (cell, formatterParams, onRendered) => {
                return getTabulatorThreeLightFormatter(cell, formatterParams, onRendered, selectedProject);
            },
            download: true,
            titleDownload: "燈號",
            accessorDownload: (value, data) => getStatusLight(data, selectedProject).colorName
        },
        { title: "#", field: "pointIdx", responsive: 1 },
        { title: "儀器名稱", field: "pointNo", responsive: 0 },
        {
            title: "物理量", field: "value", responsive: 0,
            formatter: (cell, formatterParams, onRendered) => {
                //let unitCaption = "";

                ///**@type {number} */
                //let gageTypeCode = cell.getData().gageTypeCode;

                //if (gageDefinitionsMap) {
                //    let gageDef = gageDefinitionsMap.get(gageTypeCode);
                //    if (gageDef) {
                //        unitCaption = gageDef.unitValue;
                //    }
                //}

                //const nullDisplay = "?";
                //let valueString = cell.getValue() ?? nullDisplay;
                //if (valueString !== nullDisplay) {
                //    valueString = Number(valueString).toFixed(2);
                //}

                //return valueString + " " + unitCaption;
                const row = cell.getData();
                const unit = row.unitValue || "";  // ← 直接用資料裡的單位
                const nullDisplay = "?";

                let valueString = cell.getValue();
                if (valueString == null) return `${nullDisplay} ${unit}`;

                const num = Number(valueString);
                valueString = Number.isNaN(num) ? String(valueString) : num.toFixed(2);
                return `${valueString} ${unit}`;
            },
            accessorDownload: (value, data, type, params, column) => {
                //let unitCaption = "";

                ///**@type {number} */
                //let gageTypeCode = data.gageTypeCode;

                //if (gageDefinitionsMap) {
                //    let gageDef = gageDefinitionsMap.get(gageTypeCode);
                //    if (gageDef) {
                //        unitCaption = gageDef.unitValue;
                //    }
                //}

                //const nullDisplay = "?";
                //let valueString = value ?? nullDisplay;
                //if (valueString !== nullDisplay) {
                //    valueString = Number(valueString).toFixed(2);
                //}

                //return valueString + " " + unitCaption;
                const unit = data.unitValue || "";
                const nullDisplay = "?";

                if (value == null) return `${nullDisplay} ${unit}`;
                const num = Number(value);
                const valueString = Number.isNaN(num) ? String(value) : num.toFixed(2);
                return `${valueString} ${unit}`;
            }
        },
        {
            title: "初值", field: "iniR", responsive: 1, formatter: (cell, formatterParams, onRendered) => {
                const nullDisplay = "";
                let value = cell.getValue();
                if (value === null) {
                    return nullDisplay;
                }
                let numberValue = Number(value);
                if (isNaN(numberValue)) {
                    return value;
                }
                return numberValue.toFixed(2);
            }
        },
        //{
        //    title: "單位",
        //    field: "gageTypeCode",
        //    formatter: (cell, formatterParams, onRendered) => {
        //        /**@type {number} */
        //        let value = cell.getValue();
        //        let gageDef = gageDefinition.get(value);
        //        if (gageDef) {
        //            return gageDef.unitValue;
        //        }
        //    }
        //},
        thresholdRangeColumn("警戒值", "lAlert", "uAlert"),
        thresholdRangeColumn("警示1", "lAlarm1", "uAlarm1"),
        thresholdRangeColumn("警示2", "lAlarm2", "uAlarm2"),
        thresholdRangeColumn("行動值", "lAction", "uAction"),
        {
            title: "備註", responsive: 1000,
            field: "note",
            formatter: (cell) => {
                const row = cell.getData();
                return escapeStatusMessageHtml(
                    combineStatusNotes(row.note, row.statusStaticNote)
                ).replace(/\n/g, "<br/>");
            },
            accessorDownload: (value, data) =>
                combineStatusNotes(value, data.statusStaticNote)
        },
        { title: "GeoNow 標籤", field: "tagNames", responsive: 2, sorter: "string" }
    ];
    const [tabulatorColumns, setTabuatorColumns ] = React.useState(defaultTabulatorColumns);

    // Run once    
    React.useEffect(() => {
        window.XLSX = XLSX;
    }, []);

    //geoNow.api.project.getStatusTable(token, selectedDatabaseName).then(statusDataResponse => {
    //    console.log(statusDataResponse);
    //    console.log('done');

    //    return (
    //        <>
    //            <div className="table-settings mb-4">
    //                HELLOW
    //            </div>
    //        </>
    //    );
    //});

    //let statusDataResponse = geoNow.api.project.getStatusTable(token, selectedDatabaseName);
    //console.log(statusDataResponse);
    // console.log("currentProjectId: " + rdx_project.currentProjectId);
    // console.log("joinedProjects: " + rdx_project.joinedProjects);
    // console.log(selectedProject.databaseName);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item>GeoNow</Breadcrumb.Item>
                        <Breadcrumb.Item active>資料一覽</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>資料一覽</h4>
                    <p className="mb-0" aria-live="polite"
                        title={!loadingProp.isLoading && measurementHistory?.selected?.meaNo != null ? `批次：${measurementHistory.selected.meaNo}` : undefined}>
                        {loadingProp.isLoading ? "正在讀取資料…" : statusData?.meaTime
                            ? `${historical ? '歷史' : '最新'}量測時間：${moment(measurementHistory?.selected?.date || statusData.meaTime).format('YYYY-MM-DD HH:mm:ss')}` : ""}
                    </p>
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <ButtonGroup>
                        <Button
                            variant="outline-primary"
                            size="sm"
                            disabled={loadingProp.isLoading || !selectedProject?.projectId}
                            onClick={e => {
                                e.preventDefault();
                                reloadData();
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faSync}
                                className={loadingProp.isLoading ? "fa-spin me-1" : "me-1"}
                            />
                            重新整理
                        </Button>
                        <Button disabled variant="outline-primary" size="sm">附件</Button>
                        <Button variant="outline-primary" size="sm"
                            disabled={!filteredStatusDataEntries || filteredStatusDataEntries.length === 0}
                            onClick={e => {
                                e.preventDefault();
                                if (!(tableRef?.current)) {
                                    Swal.fire({
                                        title: "錯誤",
                                        html: `列印失敗。<br/>找不到表格控制項。`,
                                        icon: 'error',
                                        showConfirmButton: true,
                                    });
                                    return;
                                }
                                tableRef.current.print();
                            }}
                        >列印</Button>
                        <Button
                            disabled={!filteredStatusDataEntries || filteredStatusDataEntries.length === 0}
                            onClick={e => {
                                e.preventDefault();
                                if (!(tableRef?.current)) {
                                    Swal.fire({
                                        title: "錯誤",
                                        html: `下載失敗。<br/>找不到表格控制項。`,
                                        icon: 'error',
                                        showConfirmButton: true,
                                    });
                                    return;
                                }
                                let csvFilename = "[" + (lastName ?? "") + (firstName ?? "") + "|" + (selectedProject?.name ?? (selectedProject?.databaseName ?? "")) + "] dataOverview@" + statusData.meaTime + ".xlsx";
                                tableRef.current.download("xlsx", csvFilename, { sheetName: "DataOverview" });
                            }}
                            variant="outline-primary" size="sm">下載</Button>
                    </ButtonGroup>
                </div>
            </div>
            {selectedProject?.projectId && (
                <MeasurementNavigation history={measurementHistory} loading={loadingProp.isLoading}
                    historical={historical} projectId={selectedProject.projectId}
                    onSelect={next => setHistorySelection({ projectId: selectedProject.projectId, selection: next })} />
            )}
            {!selectedProject?.projectId && (
                <Alert variant="info" role="status">尚未選擇專案，請先從專案選單選擇專案。</Alert>
            )}
            {loadError && (
                <Alert variant="danger" role="alert">
                    <h5>資料載入失敗</h5>
                    <p className="mb-2" style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>{loadError}</p>
                    <Button variant="outline-danger" size="sm" onClick={reloadData}>
                        <FontAwesomeIcon icon={faSync} className="me-1" />重試載入
                    </Button>
                </Alert>
            )}
            {loadWarnings.length > 0 && (
                <Alert variant="warning" role="status">
                    <h5>部分輔助資料未能載入</h5>
                    <p>已取得的量測資料仍可查看；部分單位、篩選選項或標籤可能無法顯示。可按「重新整理」再試。</p>
                    <ul className="mb-0" style={{ overflowWrap: 'anywhere' }}>
                        {loadWarnings.map(warning => <li key={warning}>{warning}</li>)}
                    </ul>
                </Alert>
            )}
            {statusData && (statusData.entries.length === 0 || statusData.message || statusData.reasonCode) && (
                <Alert variant="info" role="status">
                    <h5>{statusData.entries.length === 0 ? '此專案目前沒有可顯示的資料' : '量測資料說明'}</h5>
                    <p className="mb-0" style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>{getOverviewDataMessage(statusData)}</p>
                </Alert>
            )}
            {noFilterResults && (
                <Alert variant="info" role="status">
                    <p>已取得 {statusData.entries.length} 筆儀器資料，但目前的篩選條件沒有符合的結果。</p>
                    <Button variant="outline-primary" size="sm" onClick={clearFilters}>清除全部篩選</Button>
                </Alert>
            )}
            <Form>
                <Row className="g-2">
                    <Col md={6} lg={2}>
                        <Form.Select aria-label="儀器過濾" disabled={!statusData || !gageDefinitionsMap?.size} value={filterOptions?.gageFilter ?? "null"} onChange={e => handleGageFilterOnChange(e.target.value)}>
                            <option key="null" value="null">全部儀器</option>
                            {renderGageDropdownOptions()}
                        </Form.Select>
                    </Col>
                    <Col md={6} lg={2}>
                        <Form.Select aria-label="區域過濾" disabled={!statusData || !areaList?.items?.length} value={filterOptions?.areaFilter ?? "null"} onChange={e => handleAreaFilterOnChange(e.target.value)}>
                            <option key="null" value="null">全部區域</option>
                            {renderAreaDropdownOptions()}
                        </Form.Select>
                    </Col>
                    <Col md={6} lg={2}>
                        <Form.Select aria-label="燈號過濾" disabled={!statusData} value={filterOptions?.lightFilter ?? "all"} onChange={e => handleLightFilterOnChange(e.target.value)}>
                            {colorFilterOptions.map(item => <option key={item.value} value={item.value}>{item.caption}</option>)}
                        </Form.Select>
                    </Col>
                    <Col md={6} lg={3}>
                        <Select
                            isMulti
                            isClearable
                            isDisabled={!statusData || tagList.length === 0}
                            placeholder="依 GeoNow 標籤過濾（可多選）"
                            noOptionsMessage={() => "尚未建立標籤"}
                            options={tagList.map(tag => ({ value: tag.id, label: tag.name }))}
                            value={tagList
                                .filter(tag => selectedTagIds.includes(tag.id))
                                .map(tag => ({ value: tag.id, label: tag.name }))}
                            onChange={items => setSelectedTagIds((items || []).map(item => item.value))}
                        />
                    </Col>
                    <Col md={6} lg={3}>
                        <Form.Select value={groupMode} onChange={e => setGroupMode(e.target.value)}>
                            <option value="none">不分組</option>
                            <option value="area">依 GeoAuto 區域分組</option>
                            <option value="tags">依 GeoNow 標籤組合分組</option>
                        </Form.Select>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        
                        <ReactTabulator
                            onRef={(r) => {
                                if (!r) {
                                    return;
                                }
                                tableRef.current = r.current;
                            }}
                            options={tabluatorOptions}
                            data={filteredStatusDataEntries || []}
                            columns={tabulatorColumns}
                            layout={"fitData"}
                            events={{
                                "pageLoaded": () => {
                                    const size = tableRef.current?.getPageSize();
                                    if (!pageSizeOptions.includes(size)) return;
                                    setPageSize(size);
                                    try {
                                        localStorage.setItem(pageSizeStorageKey, JSON.stringify(size));
                                    } catch {
                                        // 儲存空間無法使用時仍保留本次畫面的選擇。
                                    }
                                },
                                "rowClick": (e, row) => {
                                    let rowData = row.getData();
                                    console.log(rowData);
                                    let pointIdx = Number(rowData.pointIdx);
                                    
                                    let tempDtRight = moment(statusData.meaTime).add(30, "minutes");
                                    let tempDtLeft = moment(statusData.meaTime).add(-1, "days");
                                    // let meaTimeStr = meaTime.format("YYYY-MM-DD HH:mm:ss");
                                    
                                    console.log(tempDtLeft.format("YYYY-MM-DD HH:mm:ss"));
                                    console.log(tempDtRight.format("YYYY-MM-DD HH:mm:ss"));

                                    history.push({
                                        pathname: Routes.TimeHistory.path,
                                        state: {

                                            

                                            dtLeft: tempDtLeft,
                                            dtRight: tempDtRight,
                                            pointIndices: Array.of(pointIdx)
                                        }
                                    });
                                }
                            }}                    
                        />
                    </Col>
                </Row>

            </Form>
            
            {/*
            <Table responsive className="table-centered rounded">
                <thead>
                    <tr>
                        <th>燈號</th>
                        <th>儀器名稱</th>
                        <th>物理量</th>
                    </tr>
                </thead>
                <tbody>

                </tbody>
            </Table>
            <div className="table-settings mb-4">
                <Row className="justify-content-between align-items-center">
                    <Col xs={8} md={6} lg={3} xl={4}>
                        <InputGroup>
                            <InputGroup.Text>
                                <FontAwesomeIcon icon={faSearch} />
                            </InputGroup.Text>
                            <Form.Control type="text" placeholder="Search" />
                        </InputGroup>
                    </Col>
                    <Col xs={4} md={2} xl={1} className="ps-md-0 text-end">
                        <Dropdown as={ButtonGroup}>
                            <Dropdown.Toggle split as={Button} variant="link" className="text-dark m-0 p-0">
                                <span className="icon icon-sm icon-gray">
                                    <FontAwesomeIcon icon={faCog} />
                                </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-right">
                                <Dropdown.Item className="fw-bold text-dark">Show</Dropdown.Item>
                                <Dropdown.Item className="d-flex fw-bold">
                                    10 <span className="icon icon-small ms-auto"><FontAwesomeIcon icon={faCheck} /></span>
                                </Dropdown.Item>
                                <Dropdown.Item className="fw-bold">20</Dropdown.Item>
                                <Dropdown.Item className="fw-bold">30</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </Row>
            </div>
            */}


        </>
    );
};
